export default __webpack_public_path__ + "static/media/stick.d6dfd2cd.svg";